<div class="screen-width">
  <div class="neq-page-wrapper">
    <div fxLayout="row" fxLayoutAlign="end">
      <div
        class="calc-block-message"
        innerText="{{ getCalcStatusErrorMessage() }}"></div>
      <div fxLayoutAlign="end center" class="neq-action-button">
        <button pButton
          *ngIf="hasRights && !isReadOnly && !loadingSaveTemp"
          [disabled]="!calculationId"
          class="neq-primeng-button primeng-flat"
          (click)="save()"
          [matTooltip]="'msg.common.icon.save' | translate"
        >
          <neq-icon svgIcon="enregistrer"></neq-icon>
        </button>

        <mat-spinner [diameter]="34" *ngIf="loadingSaveTemp"></mat-spinner>

        <button pButton
          *ngIf="exportEnabled()" [disabled]="!canExport()"
          class="neq-primeng-button primeng-flat"
          (click)="exportRequest()"
          matTooltip="{{ returnExportTooltip() }}"
        >
          <neq-icon svgIcon="exporter"></neq-icon>
        </button>

        <button pButton *ngIf="!isSampleMode"
          [disabled]="!canGenerateRmPdf()"
          class="neq-primeng-button primeng-flat"
          (click)="reportRm()"
          [matTooltip]="returnGenerateRmPdfTooltip() | translate"
        >
          <neq-icon svgIcon="pdf"></neq-icon>
        </button>
        <ng-container *ngIf="isSampleMode">
          <button pButton *ngIf="!loadingDownloadBulletin"
            [disabled]="!bulletinId"
            class="neq-primeng-button primeng-flat"
            (click)="downloadBulletin()"
            [matTooltip]="'msg.user.icon.sample.download-bulletin' | translate"
          >
            <neq-icon svgIcon="pdf"></neq-icon>
          </button>

          <mat-spinner [diameter]="34" *ngIf="loadingDownloadBulletin"></mat-spinner>

          <button pButton  *ngIf="!loadingSendBulletinMail"
            [disabled]="!canSendSampleBulletinByMail()"
            class="neq-primeng-button primeng-flat"
            (click)="sendSampleBulletinByMail()"
            [matTooltip]="'msg.user.icon.sample.send-bulletin-by-e-mail' | translate"
          >
            <neq-icon svgIcon="email"></neq-icon>
          </button>

          <mat-spinner [diameter]="34" *ngIf="loadingSendBulletinMail"></mat-spinner>
        </ng-container>

        <button pButton 
          class="neq-primeng-button primeng-flat"
          (click)="settings()"
          [matTooltip]="'msg.common.icon.rawmaterial.results.params' | translate"
        >
          <neq-icon svgIcon="parametres"></neq-icon>
        </button>
        <neq-rawmaterials-additional-actions [rawMaterial]="rawMaterialOrSample" [showDeleteButton]="false">
        </neq-rawmaterials-additional-actions>
      </div>
    </div>
    <!-- Display results tables with flex on all web browsers except Internet Explorer -->
    <div *ngIf="!isIE" fxLayout="row wrap">
      <div *ngFor="let tableNumber of tablesToShow">
        <neq-results-table [productId]="productId" [calculationId]="calculationId"
                           [rawMaterialOrSample]="rawMaterialOrSample"
                           [matrices]="matrices" [userClassKey]="'rawmaterials.results.class.' + tableNumber"
        ></neq-results-table>
      </div>
    </div>

    <!-- And a workaround for Internet Explorer because it does not support flex row wrap \o/ -->
    <div *ngIf="isIE">
      <div *ngFor="let tableNumber of tablesToShow" style="float: left;">
        <neq-results-table [productId]="productId" [calculationId]="calculationId" [rawMaterialOrSample]="rawMaterialOrSample"
          [matrices]="matrices" [userClassKey]="'rawmaterials.results.class.' + tableNumber"
        ></neq-results-table>
      </div>
    </div>
  </div>
</div>
